import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Input, {isValidPhoneNumber} from 'react-phone-number-input/input'
import {SafetyOutlined} from '@ant-design/icons'


import mailcheck from 'mailcheck';
import { fetchStateCode, getFromLocal, getQueryParam, isMobile, LCSubStr, stateCodeMatch } from "../../services/shared";
import Button from "../Button/Button";
import WhenToBuyV2 from "../WhenToBuyV2/WhenToBuyV2";
import ruleEngine from "../../services/ruleEngine";
import './Leadform.scss'

const prefillFields = [];

let facts = {};
let Filter = require('bad-words')

const LeadForm = (props)=>{

    const url = new URL(window.location);
    const params = url.searchParams;

    const phoneInputElem = useRef(null);


    const [secondPhase, setSecondPhase] = useState(true);
    const [suggestedEmail, setSuggestedEmail] = useState("");
    const [inputFocused, setInputFocused] = useState(false);
    const [enableStreet, setEnableStreet] = useState(false);
    const [enableWhenToBuy, setEnableWhenToBuy] = useState(false);
    const [streetAddressRequired, setStreetAddressRequired] = useState(true);
    const [isContentOverflowing, setIsContentOverflowing] = useState(false);
    const containerRef = useRef(null);


    const { register, handleSubmit, watch, errors, getValues, setValue:setInfoFormValues, trigger, control ,formState } = useForm({  
        mode: 'onChange',
    });
    const { isValid } = formState;

    useEffect(()=>{
        setFormValuesFromUrl();

    },[])

    useEffect(()=>{
        if(props.preSelectedUi){
            setSecondPhase(true);
        }
    },[props.preSelectedUi])

    useEffect(()=>{
        const params = new URLSearchParams(window.location.href);
        if(props.forceSecondPhase || props.templateId === "template1"){
            setSecondPhase(true)
        }
        if(params.get('skipForm') == 'true'){
            setFormValuesFromLocal();
        }
    },[])

    useEffect(()=>{
        if(props.street && enableStreet){
            setInfoFormValues('street',props.street);
        }
    },[props.street])

    useEffect(()=>{
        if(props.templateId === "template4"){
            setEnableStreet(true)
        }else if(props.templateId === "template5"){
            setEnableStreet(true)
        }else if(props.templateId == "template9"){
            setEnableWhenToBuy(true)
        }
        else if(props.make === 'Subaru' || props.make === 'Volvo'){
            setEnableWhenToBuy(true);
        }
        
    },[props.templateId])

    useEffect(()=>{
        // To skip first init as setting "" at first and then null for empty
        if(suggestedEmail !== ""){
            trigger("email");
        }
    },[suggestedEmail])

    function setFormValuesFromLocal(){
        setSecondPhase(true);
        const data = getFromLocal('personal');
        if(data){
            setInfoFormValues('firstName',data.firstName);
            setInfoFormValues('lastName',data.lastName);
            setInfoFormValues('email',data.email);
            setInfoFormValues('phone',data.phone);
            setInfoFormValues('street',data.street);
        }
    }

    const emailSuggest = e => {
        if(e.target.value){
            mailcheck.run({
                email: e.target.value,
                domains: ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'icloud.com', 'mail.com', 'aol.com', 'comcast.net', 'msn.com', 'me.com', 'test.com', 'att.net', 'cox.net'],
                secondLevelDomains: ['gmail', 'hotmail', 'outlook', 'yahoo', 'icloud', 'mail', 'aol', 'comcast', 'msn', 'me', 'test', 'att', 'cox'],
                suggested: function(suggestion) {
                    setSuggestedEmail(suggestion.full);
                },
                empty: function() {
                    setSuggestedEmail(null);
                }
            })
        }else{
            setSuggestedEmail(null);
        }
        
    }

    const profanityCheck = (firstName, lastName, email, street) => {
        const filter = new Filter()
        if(filter.isProfane(firstName))
            setInfoFormValues('firstName', '')
        if(filter.isProfane(lastName))
            setInfoFormValues('lastName', '')
        if(filter.isProfane(email))
            setInfoFormValues('email', '')
        if(filter.isProfane(street))
            setInfoFormValues('street', '')
    }

    const runRuleEngine = ()=>{
        const firstName = getValues('firstName');
        const lastName = getValues('lastName');
        const email = getValues('email');
        const phone = getValues('phone');
        const street = getValues('street');

        profanityCheck(firstName, lastName, email, street)
        if(firstName && lastName && validateEmail(email) && isValidPhoneNumber(phone, 'US')){

            facts = {
                "Email and (first & last) name correlation": LCSubStr(email, firstName+lastName),
                "State code match": stateCodeMatch(props.stateCode,phone),
                "Browser pre-fill count": prefillFields.length
            }
            props.setFacts(facts);
            ruleEngine(facts).then(res=>{
                if(res.length){
                    if(res[0].type === "Show Resistance"){
                        setEnableWhenToBuy(true);
                        window.dataLayer?.push({
                            'event': 'Showing Resistance',
                            'event_category': 'Lead Form',
                            'event_action': 'Show',
                            'event_label': 'When To Buy',
                        });
                    }
                }
            })
        }
        
    }

    const validateEmail = (e)=>{
        const passedTest = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(e)
        const passedSuggestion = !suggestedEmail;
        return  passedTest && passedSuggestion;
    }

    function setFormValuesFromUrl() {
        setInfoFormValues('firstName', params.get('firstname') || '');
        setInfoFormValues('lastName', params.get('lastname') || '');
        setInfoFormValues('email', params.get('email') || '');
        setInfoFormValues('phone', params.get('phone') || '');
        setInfoFormValues('street', params.get('street') || '');
    }

    const handleAnimationStart = (e)=>{
        if(e.animationName === "onAutoFillStart" && prefillFields.indexOf(e.target.name) === -1){
            prefillFields.push(e.target.name)
        }else if(e.animationName === "onAutoFillCancel"){
            prefillFields.splice(prefillFields.indexOf(e.target.name),1);
        }
    }

    const handleOnChange = (e)=>{
        runRuleEngine();
    }

    useEffect(()=>{
       if(window.location.pathname==="/marketplace"){
           setSecondPhase(true)
       }
    },[])

    let tcpaCssMapping={}
  const  getMKTcpaCssmapping=()=>{
        //details modal tcpa closed desktop
       if(window.innerWidth> 760 && props.showUsedCarDetailsModal && props.showMKTcpaText===false){
           tcpaCssMapping={
               //  "height":"auto",
               // "marginTop":"-20px"
               "position":"fixed",
               "bottom":"100px",
               "height":"auto",
               "width":"400px",
               "maxWidth":"-webkit-fill-available",
              // "box-shadow": "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
               "marginRight":"10px"

           }
       }
      if(window.innerWidth> 760 && window.innerHeight >640 && props.showUsedCarDetailsModal && props.showMKTcpaText===false){
          tcpaCssMapping={
              //  "height":"auto",
              // "marginTop":"-20px"
              "position":"fixed",
              "bottom":"110px",
              "height":"auto",
              "width":"400px",
              // "box-shadow": "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
              "maxWidth":"-webkit-fill-available",
              "marginRight":"10px"
          }
      }
      if(window.innerWidth> 760 && props.showUsedCarDetailsModal && props.showMKTcpaText===true){
          tcpaCssMapping={
           //  "marginTop":"-25px"
              "position":"fixed",
              "bottom":"90px",
             // "height":"auto",
              "width":"400px",
              "box-shadow": "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
              "borderRadius":"8px",
              "maxWidth":"-webkit-fill-available",

          }
      }

       //contactinfo modal tcpa closed desktop
      if(window.innerWidth> 760 && props.showContactInfo && props.showMKTcpaText===false){
          tcpaCssMapping={
             "height":"auto",
              //"marginBottom":"-38px"
              "position":"absolute",
              "bottom":"80px",
             // "width":"100%"
              "width":"400px"

          }
      }
      if(window.innerWidth< 760 && props.showContactInfo && props.showMKTcpaText===true){
          tcpaCssMapping={
              "position":"absolute",
              "bottom":"100px",
              "width":"90%"

          }
      }
      if(window.innerWidth> 760 && props.showContactInfo && props.showMKTcpaText===true){
          tcpaCssMapping={
              "position":"absolute",
              "bottom":"90px",
              "width":"92%",
              "height":"auto"

          }
      }

      if(window.innerWidth<760 && props.showContactInfo && props.showMKTcpaText===false){
          tcpaCssMapping={
            // "marginTop":"-30px",
              "marginBottom":"10px",
              "marginTop":"-20px"
          }
      }
      if(window.innerWidth< 760 && props.showUsedCarDetailsModal && props.showMKTcpaText===true && (props.make==="Volvo" || props.make==="Subaru")){
          tcpaCssMapping={
            "position":"absolute",
              "bottom":"-120px",
              "width":"90%"
          }
      }
      if(window.innerWidth< 760 && props.showContactInfo && props.showMKTcpaText===true && (props.make==="Volvo" || props.make==="Subaru")){
          tcpaCssMapping={
              "position":"absolute",
              "bottom":"-120px",
              "width":"90%"
          }
      }
       return tcpaCssMapping
   }

   let submitMKBtnCssMapping={}
    const  getMKSubmitBtnCssmapping=()=>{
        if(window.innerWidth> 760 && props.showUsedCarDetailsModal && props.showMKTcpaText===false){
            submitMKBtnCssMapping={
               // "bottom":"30px",
                "position":"fixed",
                "bottom":"20px",
                "width":"400px",
                "maxWidth":"-webkit-fill-available",
                "marginRight":"10px"
            }
        }
        if(window.innerWidth> 760 && props.showUsedCarDetailsModal && props.showMKTcpaText===true){
            submitMKBtnCssMapping={
                //"marginTop":"-40px",
                "position":"fixed",
                "bottom":"20px",
                "width":"400px",
                "maxWidth":"-webkit-fill-available",
                "marginRight":"10px"
            }
        }
        if(window.innerWidth< 760 && props.showContactInfo && props.showMKTcpaText===false){
            submitMKBtnCssMapping={
               // "bottom":"30px",
                "marginBottom":"-20px"
            }
        }

        if(window.innerWidth> 760 && props.showContactInfo && props.showMKTcpaText===true){
            submitMKBtnCssMapping={
               // "marginTop":"80px"
                "position":"absolute",
                "bottom":"0px",
                "width":"400px"
            }
        }
        if(window.innerWidth> 760 && props.showContactInfo && props.showMKTcpaText===false){
            submitMKBtnCssMapping={
                // "marginTop":"80px"
                "position":"absolute",
                "bottom":"0px",
                "width":"400px"
            }
        }
        //details modal tcpa closed/open mobile
        if(window.innerWidth< 760 && props.showUsedCarDetailsModal ){
            submitMKBtnCssMapping={
                "marginBottom":"-20px"

            }
        }
        //contactinfo mobile tcpa closed
        if(window.innerWidth<760 && props.showContactInfo && props.showMKTcpaTextsm===false){
            submitMKBtnCssMapping={
                "marginBottom":"-20px"
            }
        }
        if(window.innerWidth<760 && props.showContactInfo && props.showMKTcpaTextsm===true){
            submitMKBtnCssMapping={
                "bottom":"0px"
            }
        }
        if(window.innerWidth< 760 && window.innerWidth >400  && props.showContactInfo && props.showMKTcpaText===true && (props.make==="Volvo" || props.make==="Subaru")){
            submitMKBtnCssMapping={
                "marginTop":"180px"
            }

        }
        if(window.innerWidth <390  && props.showContactInfo && props.showMKTcpaText===true && (props.make==="Volvo" || props.make==="Subaru")){
            submitMKBtnCssMapping={
                "marginTop":"0px"
            }

        }
        return submitMKBtnCssMapping
    }

    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);


    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 700);

        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const [isGrt640Desktop, setIsGrt640Desktop] = useState(window.innerHeight > 640);


    useEffect(() => {
        const handleResize = () => {
            setIsGrt640Desktop(window.innerWidth > 640);

        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    // useEffect(()=>{
    //   if(window.location.pathname==="/marketplace"){
    //       if(props.optInCheckBoxvalue===false && props.submitBtnClicked){
    //           props.setShowTcpaError(true)
    //       }else{
    //           props.setShowTcpaError(false)
    //       }
    //   }
    // },[props.submitBtnClicked,props.optInCheckBoxvalue])

    useEffect(()=>{
       if(window.location.pathname==="/marketplace"){
           props.setSubmitBtnClicked(false)
          // props.setOptInCheckboxValue(false)
       }
    },[])

    useEffect(() => {
        const container = containerRef.current;
        console.log(container.scrollHeight)
        console.log(container.clientHeight)
        const handleResize = () => {
            console.log(container.scrollHeight)
            console.log(container.clientHeight)
            if (container) {
                setIsContentOverflowing(container.scrollHeight > container.clientHeight);
            }
        };

        handleResize(); // Initial check

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        // Register the input using the register function and the custom ref
        if(props.showUsedCarDetailsModal && !isDesktop){
            register(props.tcpaInputRef.current);
        }

    }, [register,props.showUsedCarDetailsModal ,isDesktop]);

    useEffect(() => {
        genrateSymId();
    }, []);

    function genrateSymId() {
        let input = document.querySelector('#vsid-test-input')
        window.wmnjs = window.wmnjs || {};
        window.wmnjs.que = window.wmnjs.que || [];
        window.wmnjs.que.push(() => {
            window.wmnjs.fillVsid(input);
        });
    }

    return (
        <form onSubmit={handleSubmit(props.onSubmit)}>
            <div  ref={containerRef} className={`lead-form ${(window.location.pathname=="/marketplace" && isDesktop ) && ( (streetAddressRequired || enableWhenToBuy || Object.keys(errors).length > 0)? 'leadform-scrollbar':"leadform-scrollbar-hidden")}`}  style={(window.location.pathname === "/marketplace" && isDesktop ) ?(props.showUsedCarDetailsModal?{ height: "348px", overflowY: "scroll", paddingRight: "10px" }:(props.showContactInfo && isGrt640Desktop) ?{ height: "348px", marginBottom:"90px",overflowY: "scroll", paddingRight: "10px" }:{ height: "348px", marginBottom:"70px",overflowY: "scroll", paddingRight: "10px" } ): {}}>
                <div className={`field ${errors.firstName?'error':''}`}>
                    <div>
                        <input 
                            name="firstName"
                           // style={errors.firstName ?{padding:"8px 8px 13px 8px"}:{}}
                            maxLength="20"
                            minLength="2"
                            type="text"
                            ref={register({ required: true })} 
                            value={watch("firstName")} 
                            onAnimationStart={handleAnimationStart} 
                            onChange={(e) => {
                                setInfoFormValues('firstName', e.target.value)
                                handleOnChange()
                            }}
                            onFocus={()=>{setInputFocused(true)}} 
                            onBlur={()=>{
                                setInputFocused(false);
                                window.dataLayer?.push({
                                    'event': 'Entered first name',
                                    'event_make': props.make,
                                    'event_model': props.model,
                                    'event_year': props.year,
                                    'event_trim': props.trim
                                });
                            }} ></input>
                        <label>First Name</label>
                    </div>
                    { 
                        errors.firstName && 
                        <div className="error-msg">This field is required.</div>
                    }
                </div>
                <div className={`field ${errors.lastName?'error':''}`}>
                    <div>
                        <input
                           // style={errors.lastName ?{padding:"8px 8px 13px 8px"}:{}}
                            name="lastName" 
                            maxLength="20"
                            minLength="2"
                            type="text" 
                            ref={register({ required: true })} 
                            onAnimationStart={handleAnimationStart} 
                            onChange={(e) => {
                                setInfoFormValues('lastName', e.target.value)
                                handleOnChange()
                            }}
                            value={watch("lastName")} 
                            onFocus={()=>{setInputFocused(true)}} 
                            onBlur={()=>{
                                setInputFocused(false);
                                window.dataLayer?.push({
                                    'event': 'Entered last name',
                                    'event_make': props.make,
                                    'event_model': props.model,
                                    'event_year': props.year,
                                    'event_trim': props.trim
                                });
                            }}></input>
                        <label>Last Name</label>
                    </div>
                    { 
                        errors.lastName && 
                        <div className="error-msg">This field is required.</div>
                    }
                </div>
                {
                    !secondPhase && <>
                    <div className="field extra-top">
                        <Button className={`xl primary ${secondPhase ? "" : " gcd-cta-two "}`} onClick={()=>{
                            setSecondPhase(true);
                            props.nextClicked()
                        }}>Continue</Button>
                    </div>
                        {window.location.pathname!=="/marketplace" &&
                            ( (params.get('tmpl')==='t2' || params.get('tmpl')==='t1' || params.get('tmpl')==='t3' ) && window.location.pathname === '/deals'? (props.showTCPAtext===true ? <><div className="disclaimer" style={window.innerWidth <= 760 ?{fontSize:"9px",textAlign:"justify",lineHeight:"15px",color:"rgba(0, 0, 0, 0.30)"} :{fontSize:"11px",textAlign:"justify",lineHeight:"15px",color:"rgba(0, 0, 0, 0.30)"}}>
                                {
                                    // Generate LeadID For Production OR Phonexa template
                                    process.env.REACT_APP_ENV === "production" || params.get('new') ?
                                        <>
                                            <input
                                                name="universal_leadid"
                                                type="hidden"
                                                ref={register()}
                                                id="leadid_token"
                                            ></input>
                                            <input
                                                name="leadid_tcpa_disclosure"
                                                type="hidden"
                                                ref={register()}
                                                id="leadid_tcpa_disclosure"
                                            ></input>
                                            <label htmlFor="leadid_tcpa_disclosure">
                                                *By clicking next, I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list.  If
                                                you prefer not to receive these calls on a mobile phone, provide us with a landline phone number.
                                                <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information</a>
                                            </label>
                                        </>
                                        :
                                        <>
                                            *By clicking next, I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list.  If
                                            you prefer not to receive these calls on a mobile phone, provide us with a landline phone number.
                                            <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information</a>
                                        </>
                                }
                            </div></>:<></> ): <div className="disclaimer">
                                {
                                    // Generate LeadID For Production OR Phonexa template
                                    process.env.REACT_APP_ENV === "production" || params.get('new') ?
                                        <>
                                            <input
                                                name="universal_leadid"
                                                type="hidden"
                                                ref={register()}
                                                id="leadid_token"
                                            ></input>
                                            <input
                                                name="leadid_tcpa_disclosure"
                                                type="hidden"
                                                ref={register()}
                                                id="leadid_tcpa_disclosure"
                                            ></input>
                                            <label htmlFor="leadid_tcpa_disclosure">
                                                *By clicking next, I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list.  If
                                                you prefer not to receive these calls on a mobile phone, provide us with a landline phone number.
                                                <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information</a>
                                            </label>
                                        </>
                                        :
                                        <>
                                            *By clicking next, I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list.  If
                                            you prefer not to receive these calls on a mobile phone, provide us with a landline phone number.
                                            <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information</a>
                                        </>
                                }
                            </div>)
                        }

                    </>
                }
                <div className={`${props.forceSecondPhase?'':'hidden-fields'} ${secondPhase?'show':''}`} style={window.location.pathname==="/marketplace"?{transform:"none"}:{}}>
                    <div className={`field ${errors.email?'error':''}`}>
                        <div>
                            <input
                               // style={errors.email?{padding:"8px 8px 13px 8px"}:{}}
                                name="email"
                                maxLength="50" 
                                type="text" 
                                ref={register({ 
                                    required: true, 
                                    validate: validateEmail
                                }) } 
                                value={watch("email")} 
                                onAnimationStart={handleAnimationStart} 
                                onChange={(e) => {
                                    setInfoFormValues('email', e.target.value)
                                    handleOnChange()
                                }}
                                onFocus={()=>{setInputFocused(true)}} 
                                onBlur={(e)=>{
                                    runRuleEngine()
                                    setInputFocused(false);
                                    emailSuggest(e);
                                    window.dataLayer?.push({
                                        'event': 'Entered email',
                                        'event_make': props.make,
                                        'event_model': props.model,
                                        'event_year': props.year,
                                        'event_trim': props.trim
                                    });
                                }}></input>
                            <label>Email</label>
                        </div>
                        {
                            suggestedEmail &&
                            <div className="suggested-value">Did you mean <span onClick={()=>{
                                phoneInputElem.current.focus();
                                setInfoFormValues('email',suggestedEmail);
                                setSuggestedEmail(null);
                            }}>{suggestedEmail} </span></div>
                        }
                        { 
                            (errors.email && !suggestedEmail) && 
                            <div className="error-msg">Please enter a valid email address.</div>
                        }
                    </div>
                    
                    <div className={`field ${errors.phone?'error':''}`}>
                        <div>
                            
                            <Input
                               // style={errors.phone ?{padding:"8px 8px 13px 8px"}:{}}
                                name="phone"
                                country="US"
                                international
                                withCountryCallingCode
                                control={control}
                                value={watch("phone")} 
                                onAnimationStart={handleAnimationStart} 
                                onFocus={()=>{setInputFocused(true)}} 
                                onChange={(e)=>{
                                    handleOnChange();
                                }}
                                onKeyUp={handleOnChange}
                                onBlur={()=>{
                                    setInputFocused(false);
                                    window.dataLayer?.push({
                                        'event': 'Entered phone number',
                                        'event_make': props.make,
                                        'event_model': props.model,
                                        'event_year': props.year,
                                        'event_trim': props.trim
                                    });
                                }}
                                ref={(e)=>{
                                    register(
                                        e,{
                                            required: true,
                                            validate: (e)=>{
                                                try{
                                                    console.log(isValidPhoneNumber(e, 'US'))
                                                    return isValidPhoneNumber(e, 'US')
                                                }catch(e){}
                                                return false;
                                            }
                                        }   
                                    );
                                    phoneInputElem.current = e;
                                }} >
                            </Input>
                            <label>Phone</label>
                        </div>
                        {
                            errors.phone &&
                            <div className="error-msg">Please enter a valid US phone number.</div>
                        }
                    </div>
                    
                    <div className={`field ${errors.street?'error':''}`}>
                        <div>
                            <input
                                name="street" 
                                maxLength="100" 
                                type="text" 
                                ref={register({ required: streetAddressRequired})} 
                                value={watch("street")} 
                                onAnimationStart={handleAnimationStart} 
                                onChange={(e) => {
                                    setInfoFormValues('street', e.target.value)
                                    handleOnChange()
                                }}
                                onFocus={()=>{setInputFocused(true)}} 
                                onBlur={(e)=>{
                                    setInputFocused(false);
                                    window.dataLayer?.push({
                                        'event': 'Entered street',
                                        'event_make': props.make,
                                        'event_model': props.model,
                                        'event_year': props.year,
                                        'event_trim': props.trim
                                    });
                                }}></input>

                            <label>Street Address</label>
                        </div>
                        {
                            (props.city && props.stateCode && props.zip) && params.get('utm_source')?.toLowerCase() !== "buyerlink" &&
                            <span className="field-secondary">{`${props.city}, `}<span className="upper-case">{props.stateCode} </span> {props.zip}</span>
                        }
                        { 
                            errors.street && 
                            <div className="error-msg">Please enter a street address.</div>
                        }
                    </div>
                    
                        <div className={`field ${errors.whenToBuy?'error':''} hide ${enableWhenToBuy?'show':''}`}>
                            {
                                enableWhenToBuy && 
                                <>
                                <WhenToBuyV2
                                    optionSelected={(e)=>{
                                        window.dataLayer?.push({
                                            'event': 'Entered when to buy',
                                            'event_make': props.make,
                                            'event_model': props.model,
                                            'event_year': props.year,
                                            'event_trim': props.trim
                                        });
                                    }}
                                    name="whenToBuy"
                                    control={control}
                                ></WhenToBuyV2>
                                { 
                                    errors.whenToBuy && 
                                    <div className="error-msg">Please select when you plan to buy this car.</div>
                                }
                                </>
                            }
                            
                        </div>
                        <input type="hidden" id="vsid-test-input"></input>
                    {window.location.pathname!=='/marketplace' && <p  className="text-center secure-information disclaimer mb-16px"> <SafetyOutlined style={{ color: 'green' }}/> Your information is securely stored</p>}

                    {
                        ( (window.location.pathname==='/marketplace' && props.selectedCar?.tag==="USED") && !(props.showUsedCarDetailsModal && !isDesktop) )&& <>

                                <div className="marketplace-tcpa" style={getMKTcpaCssmapping()} >
                                    <input
                                        name="universal_leadid"
                                        type="hidden"
                                       // ref={register()}
                                        ref={(el) => {
                                            // Attach both refs to the input field
                                            if(props.showUsedCarDetailsModal && !isDesktop){
                                                props.tcpaInputRef.current = el;
                                            }

                                            register(el);
                                        }}

                                        id="leadid_token"
                                    ></input>
                                    {/*<input*/}
                                    {/*    className="marketplace-tcpa-checkbox"*/}
                                    {/*    id="marketplace-tcpa-checkbox"*/}
                                    {/*    type="checkbox"*/}
                                    {/*    onChange={()=>{*/}
                                    {/*        window.dataLayer?.push({*/}
                                    {/*            'event': 'Select T&C'*/}
                                    {/*        });*/}
                                    {/*        props.setOptInCheckboxValue(!props.optInCheckBoxvalue)*/}
                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*</input>*/}
                                    {props.showMKTcpaText || props.showMKTcpaTextsm ?<><label htmlFor="marketplace-tcpa-checkbox" className="marketplace-tcpa-text" style={{textDecoration:"none"}}> *By clicking Request Quote, I authorize dealers, Autoweb, Inc. and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. If you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. Please refer to the usage of your personal information</label>
                                        <svg onClick={()=>
                                            {
                                                if(props.showMKTcpaText===true){ props.setShowMKTcpaText(false)};
                                                if(props.showMKTcpaTextsm===true) {props.setShowMKTcpaTextsm(false)}
                                            }}
                                         className="tcpa-collapse-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 1.5L6 6.5L1 1.5" stroke="#B5B5B5" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg></> :<><label htmlFor="marketplace-tcpa-checkbox"  className="marketplace-tcpa-text" style={{cursor:"pointer"}} onClick={()=>
                                    {
                                       if(props.showMKTcpaText===false){ props.setShowMKTcpaText(true)};
                                       if(props.showMKTcpaTextsm===false) {props.setShowMKTcpaTextsm(true)}
                                    }

                                        } ><span  style={(window.innerWidth< 760 && props.showContactInfo && props.showMKTcpaTextsm===false)?{fontSize:"10px",textDecoration:"underline"}:{textDecoration:"underline",fontSize:"12px"}} >*By clicking Request Quote, I authorize dealers, Autoweb...</span></label>
                                        <svg onClick={()=>{
                                            if(props.showMKTcpaText===false){  props.setShowMKTcpaText(true)};
                                            if(props.showMKTcpaTextsm===false) { props.setShowMKTcpaTextsm(true)};
                                        }} className="tcpa-collapse-arrow"  width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11 6.5L6 1.5L1 6.5" stroke="#B5B5B5" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </>}
                                </div>

                        </>
                    }
                    {
                        ( (window.location.pathname==='/marketplace' && props.selectedCar?.tag==="NEW") && !(props.showUsedCarDetailsModal && !isDesktop) )&& <>

                            <div className="marketplace-tcpa" style={getMKTcpaCssmapping()} >
                                <input
                                    name="universal_leadid"
                                    type="hidden"
                                    ref={(el) => {
                                        if(props.showUsedCarDetailsModal && !isDesktop){
                                            props.tcpaInputRef.current = el;
                                        }
                                        register(el);
                                    }}

                                    id="leadid_token"
                                ></input>
                                {/*<input*/}
                                {/*    className="marketplace-tcpa-checkbox"*/}
                                {/*    id="marketplace-tcpa-checkbox"*/}
                                {/*    type="checkbox"*/}
                                {/*    onChange={()=>{*/}
                                {/*        window.dataLayer?.push({*/}
                                {/*            'event': 'Select T&C'*/}
                                {/*        });*/}
                                {/*        props.setOptInCheckboxValue(!props.optInCheckBoxvalue)*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*</input>*/}
                                {props.showMKTcpaText || props.showMKTcpaTextsm ?<><label htmlFor="marketplace-tcpa-checkbox" className="marketplace-tcpa-text" style={{textDecoration:"none"}}> *By clicking Request Quote, I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list.  If
                                    you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information</a></label>
                                    <svg onClick={()=>
                                    {
                                        if(props.showMKTcpaText===true){ props.setShowMKTcpaText(false)};
                                        if(props.showMKTcpaTextsm===true) {props.setShowMKTcpaTextsm(false)}
                                    }}
                                         className="tcpa-collapse-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 1.5L6 6.5L1 1.5" stroke="#B5B5B5" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg></> :<><label htmlFor="marketplace-tcpa-checkbox"  className="marketplace-tcpa-text" style={{cursor:"pointer"}} onClick={()=>
                                {
                                    if(props.showMKTcpaText===false){ props.setShowMKTcpaText(true)};
                                    if(props.showMKTcpaTextsm===false) {props.setShowMKTcpaTextsm(true)}
                                }

                                } ><span  style={(window.innerWidth< 760 && props.showContactInfo && props.showMKTcpaTextsm===false)?{fontSize:"10px",textDecoration:"underline"}:{textDecoration:"underline",fontSize:"12px"}} >*By clicking Request Quote, I authorize dealers, and partners to </span></label>
                                    <svg onClick={()=>{
                                        if(props.showMKTcpaText===false){  props.setShowMKTcpaText(true)};
                                        if(props.showMKTcpaTextsm===false) { props.setShowMKTcpaTextsm(true)};
                                    }} className="tcpa-collapse-arrow"  width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 6.5L6 1.5L1 6.5" stroke="#B5B5B5" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </>}
                            </div>

                        </>
                    }

                    <div className={`field extra-top flex ${isMobile() && !inputFocused && window.location.pathname!=="/marketplace"?'sticky':''} ${params.get("utm_source")?.toLowerCase() === "buyerlink" ? ' justify-space-between' : ''}`} style={getMKSubmitBtnCssmapping()}>
                        {
                            params.get("utm_source")?.toLowerCase() === "buyerlink" &&
                            <div className="price-section">
                                <span>MSRP*</span>
                                {
                                    props.trim?.split(' - ')[1] ? <p className="car-price">{`${props.trim?.split(' - ')[1]?.substring(0,3)},${props.trim?.split(' - ')[1]?.substring(3)}`}</p> : <p className="car-price shimmer-text shimmer-animation"></p>
                                }
                                
                            </div>
                        }
                        { ((props.showUsedCarDetailsModal===true && window.innerWidth>760) || (props.showContactInfo) || window.location.pathname!=="/marketplace")&& <Button loading={props.isFormSubmitting} onClick={() =>{
                        if(window.location.pathname==="/marketplace"){
                            props.setSubmitBtnClicked(true)
                        }}
                        } className={`xl primary ${isValid ? "gcd-submit-form" : ""}`} type="submit" >{props.ctaText?"See Price Now":(window.location.pathname!=="/marketplace"?"Submit":"Request Quote")}</Button>}
                        {(!props.optInCheckBoxvalue && props.showTcpaError)&& <p style={props.showContactInfo && !isDesktop ?{color:"var(--error-color)",marginTop:"6px",lineHeight:"16px",fontSize:"12px",position:"absolute",bottom:"0px"}:{color:"var(--error-color)",marginTop:"6px",lineHeight:"16px",fontSize:"12px",position:"absolute",bottom:"-15px"}}>Please check acknowledgement</p>}

                        <button ref={props.submitButtonRef} style={{display:"none"}}className="xl primary" type="submit">Submit
                        </button>

                    </div>
                    { window.location.pathname!=='/marketplace' && ((params.get('tmpl')==='t2'  || params.get('tmpl')==='t1' || params.get('tmpl')==='t3') && window.location.pathname === '/deals'?(props.showTCPAtext===true || props.preSelectedUi === true ? <div className="disclaimer" style={window.innerWidth <= 760 ?{fontSize:"14px",textAlign:"justify",lineHeight:"22px",color:"rgba(37, 41, 59, 0.60)"} :{fontSize:"13px",textAlign:"justify",lineHeight:"21px",color:"rgba(37, 41, 59, 0.60)"}}>
                        {
                            // Generate LeadID For Production OR Phonexa template
                            process.env.REACT_APP_ENV === "production" || params.get('new') ?
                                <>
                                    <input
                                        name="universal_leadid"
                                        type="hidden"
                                        ref={register()}
                                        id="leadid_token"
                                    ></input>
                                    <input
                                        name="leadid_tcpa_disclosure"
                                        type="hidden"
                                        ref={register()}
                                        id="leadid_tcpa_disclosure"
                                    ></input>
                                    <label htmlFor="leadid_tcpa_disclosure">
                                        *By clicking 'Submit', I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. If you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information.</a>
                                    </label>
                                </>
                                :
                                <>
                                    *By clicking 'Submit', I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. If you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information.</a>
                                </>
                        }
                    </div>:<></>): <div className="disclaimer">
                        {
                            // Generate LeadID For Production OR Phonexa template
                            process.env.REACT_APP_ENV === "production" || params.get('new') ?
                                <>
                                    <input
                                        name="universal_leadid"
                                        type="hidden"
                                        ref={register()}
                                        id="leadid_token"
                                    ></input>
                                    <input
                                        name="leadid_tcpa_disclosure"
                                        type="hidden"
                                        ref={register()}
                                        id="leadid_tcpa_disclosure"
                                    ></input>
                                    <label htmlFor="leadid_tcpa_disclosure">
                                        *By clicking 'Submit', I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. If you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information.</a>
                                    </label>
                                </>
                                :
                                <>
                                    *By clicking 'Submit', I authorize dealers, and partners to contact me with offers about auto or service by telephone calls, emails, artificial voice, and pre-recorded/text messages, using an automated telephone technology, to the number and email I provided above, even if my number is a mobile number or is currently listed on any state, federal or corporate Do Not Call list. If you prefer not to receive these calls on a mobile phone, provide us with a landline phone number. <a href={`/privacy-policy?${getQueryParam(params)}`}> Please refer to the usage of your personal information.</a>
                                </>
                        }
                    </div>)}

                </div>
                
                
            </div>
        </form>
    )
}

export default LeadForm;